import { createContext } from 'react';

export const ExternalContext = createContext();
 
export default ExternalContext;